import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=5f6a86d0&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=ts&"
export * from "./Details.vue?vue&type=script&lang=ts&"
import style0 from "./Details.vue?vue&type=style&index=0&id=5f6a86d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a86d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6a86d0')) {
      api.createRecord('5f6a86d0', component.options)
    } else {
      api.reload('5f6a86d0', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=5f6a86d0&scoped=true&", function () {
      api.rerender('5f6a86d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Details.vue"
export default component.exports